<template>

  <body style="direction: rtl; text-align: right; padding: 70px 0;">
    <div class="container mb-4">
      <!-- Header START -->
      <Header pageTitle="إدارة أعمالي" />
      <!-- Header END -->

      <!-- Work Cards START -->
      <div class="work-cards mt-3">
        <!-- كارد واحد لكل عمل -->
        <div v-for="(work, index) in works" :key="index" class="work-card mb-3">
          <!-- مستطيل الصورة -->
          <div class="image-placeholder">
            <!-- <img
                v-if="work.portfolio_image"
                :src="imageURL(work.portfolio_image)"
                alt="صورة العمل"
                class="work-image"
              /> -->
            <img class="work-image"
              :src="work.portfolio_image || work.portfolio_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/portfolio/image/${work.portfolio_image}` : 'assets/images/avatar/default-avatar.jpg'"
              alt="Profile">
          </div>

          <!-- محتوى الكارد: العنوان والوصف والتاريخ -->
          <div class="p-3">
            <!-- العنوان مع أيقونة القفل إن أردت -->
            <div class="d-flex align-items-center mb-1">
              <h5 class="mb-0 flex-grow-1" style="color: #296080;">{{ work.portfolio_title }}</h5>
              <!-- مثال على أيقونة قفل إن كان العمل خاصاً -->
              <!-- <i class="bi bi-lock ms-2" v-if="work.isPrivate"></i> -->
            </div>

            <!-- وصف العمل -->
            <p class=" mb-2">{{ work.portfolio_content }}</p>

            <!-- التاريخ أو الوقت -->
            <small>
              <i class="bi bi-calendar-event me-1"></i>
              {{ formatDate(work.portfolio_at_create) }}
            </small>
          </div>
        </div>
        <!-- كارد END -->
      </div>
      <!-- Work Cards END -->

      <!-- زر إضافة عمل جديد ثابت في الأسفل -->
      <router-link to="/add-work" class="btn rounded-pill shadow"
        style="position: fixed;background-color: #296080;color: white; bottom: 20px; left: 50%; transform: translateX(-50%); padding: 0.6rem 1.5rem;">
        <i class="bi bi-plus me-2"></i> إضافة عمل جديد
      </router-link>
    </div>
  </body>
</template>

<script>
import axios from 'axios';
import Header from "../../components/header.vue";

export default {
  name: "MyWorks",
  components: {
    Header,
  },
  data() {
    return {
      works: [], // سيُخزن هنا بيانات الأعمال
    };
  },
  mounted() {
    this.fetchWorks();
  },
  methods: {
    // جلب بيانات الأعمال من السيرفر
    async fetchWorks() {
      const userId = localStorage.getItem("userId");
      console.log("userId:", userId);
      if (!userId) {
        console.error("لا يوجد userId في localStorage.");
        return;
      }

      try {
        const response = await axios.post(
          "https://zadcodeonline.com/ahmad/etqan/backEnd/portfolio/view_portfolio.php",
          { usersid: userId },
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (response.data.status === "success") {
          this.works = response.data.data; // مصفوفة الأعمال
          console.log("أعمال المستخدم:", this.works);
        } else {
          console.error("فشل في جلب بيانات الأعمال:", response.data);
        }
      } catch (error) {
        console.error("خطأ أثناء جلب بيانات الأعمال:", error);
      }
    },

    // إرجاع الرابط الكامل للصورة
    imageURL(imageName) {
      return `https://zadcodeonline.com/ahmad/etqan/backEnd/upload/works/${imageName}`;
    },

    // تنسيق التاريخ (مثال مبسط)
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      // تنسيق "18/02/2025 10:30" مثلاً
      return date.toLocaleDateString("ar-sy", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }) + " " + date.toLocaleTimeString("ar-sy", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.work-card {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  overflow: hidden;
}

/* مستطيل الصورة في أعلى الكارد */
.image-placeholder {
  width: 100%;
  height: 140px;
  /* يمكنك تغيير الارتفاع حسب رغبتك */
  background-color: #f2f2f2;
  position: relative;
}

/* الصورة تأخذ المساحة كاملة داخل المستطيل */
.work-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>